"use client";
import React, { useEffect } from "react";
import Header from "../Header";
import Footer from "../Footer";
import { useNavigate } from "react-router-dom";


const AboutUs = () => {
  useEffect(() => {
    window.scrollTo(0, 0); 
  }, []);
const navigate = useNavigate();
const handleNavigation = (path) => navigate(path);

  return (
    <div>
     

      <main className="flex pb-4 w-full h-auto bg-[#fff8ef] max-xl:flex-col max-xl:gap-5 max-md:p-5 max-sm:p-4">
        <section className="flex flex-col flex-1 gap-5 min-w-0">
          <div className="bg-[#fff8ef] h-auto ">
            {/* Heading */}
            {/* <h2
              className="
                text-lg sm:text-xl md:text-xl lg:text-xl
                font-semibold
                text-gray-800
                mb-4 sm:mb-6
                text-center sm:text-left
                pl-0 sm:pl-8 md:pl-10 lg:pl-[36px]
                ml-0 sm:ml-8 md:ml-14
              "
            >
              About Us
            </h2> */}

            {/* Card */}
            <div className="bg-white rounded-2xl shadow-lg mt-4 p-8 max-w-5xl mx-auto">
              {/* Logo + Title */}
              <div className="flex items-center justify-center gap-3 mb-8">
               <div
            className=" text-3xl sm:text-3xl md:text-3xl lg:text-4xl 
      font-bold leading-none text-black 
      tracking-[1px] md:tracking-[2px] 
      hover:opacity-80 transition-opacity duration-200 
      flex-shrink-0 min-w-0
      
      lg:[-webkit-text-stroke:2px_gray-700]"
            
            aria-label="Manaprint Home"
          >
            About Us
          </div>
  
              </div>

              {/* Content */}
              <div className="space-y-5 text-gray-700 leading-relaxed">
                <p>
                  <strong>Manaprint</strong> is a custom-print design studio focused on bringing
                  your memories and ideas to life. We design and produce high-quality fridge
                  magnets, photo frames, mobile cases, desk & wall decorations, and personalized
                  gifts for individuals and businesses.
                </p>

                <p>
                  <strong>Our mission:</strong> to make beautiful, durable, and affordable custom
                  products that help people celebrate moments, decorate spaces, and promote brands —
                  while keeping the process simple and delightful.
                </p>

                <p>
                  <strong>What we do:</strong> we combine easy-to-use online design tools with
                  careful production — offering ready templates, photo upload, and full-preview proofs
                  so you know exactly what you’ll get before we print.
                </p>

                <p>
                  <strong>Quality & craftsmanship:</strong> every Manaprint product is produced using
                  premium materials and print finishes. We inspect each item before packing to ensure
                  colors, fit, and durability meet our standards.
                </p>

                <p>
                  <strong>Customization made simple:</strong> whether you need a single keepsake,
                  a batch of corporate giveaways, or home décor that matches your aesthetic, our
                  team helps you from file prep to final delivery.
                </p>

                <p>
                  <strong>Sustainability:</strong> we aim to minimize waste by using responsible
                  sourcing and efficient production methods. Where possible, we select recyclable
                  packaging and materials.
                </p>

                <p>
                  <strong>For businesses:</strong> we offer bulk pricing, branding services, and
                  fulfillment support for reseller or corporate gifting needs.
                </p>

                <p>
                  <strong>Get in touch:</strong> have a custom idea or bulk request? Visit our
                  Contact page or email <strong>manaprint6@gmail.com</strong> — we’ll be happy
                  to help bring it to life.
                </p>

                <p className="text-sm text-gray-500">
                  Join the Manaprint community — less clutter, more personality, and custom
                  products that last.
                </p>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
};

export default AboutUs;
